// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__12EtJ","title":"card_title__Upjdm","inActive":"card_inActive__w0Rdw"};